import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "@mui/material";

import { UW_EMAIL } from "@covertree/consts";

export type UWReviewRecordType = "quote" | "endorsement";

export function AgentStepsList({
  recordType = "quote",
  fontSize,
}: {
  recordType?: UWReviewRecordType;
  fontSize?: number;
}) {
  return (
    <Box my={2}>
      <Typography fontSize={fontSize}>
        If you want to move further, please email{" "}
        <Link fontWeight={500} href={`mailto:${UW_EMAIL}`} underline="none">
          {UW_EMAIL}
        </Link>{" "}
        and include the {recordType} or policy ID in your message. Be sure to
        attach any relevant documents or context, if available. Our team
        typically responds within one business day.
      </Typography>
    </Box>
  );
}

export function D2CStepsList() {
  return (
    <Box component="ul" sx={{ paddingInlineStart: "20px" }}>
      <Typography component="li" color="secondary">
        Covertree reviews your unique property and personalizes coverages
      </Typography>

      <Typography component="li" color="textSecondary" mt={2}>
        Covertree rep will reach out to you when your application is approved
      </Typography>

      <Typography component="li" color="textSecondary" mt={2}>
        Provide payment and get covered!
      </Typography>
    </Box>
  );
}
